$(window).on("load resize orientationchange", function (){
    $(".hamburger").addClass("hamburger-can-hover");
});
